module.exports = __webpack_public_path__ + "img/0-67.1504c8d3.jpg";